import { render, staticRenderFns } from "./similarity_pill.vue?vue&type=template&id=b779375c&scoped=true&"
import script from "./similarity_pill.vue?vue&type=script&lang=js&"
export * from "./similarity_pill.vue?vue&type=script&lang=js&"
import style0 from "./similarity_pill.vue?vue&type=style&index=0&id=b779375c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b779375c",
  null
  
)

export default component.exports